import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import JobListing from "./JobListing";
import { useGetJobListingByClientQuery } from "../../../../features/jobs/jobsApiSlice";
import { setCandidates } from "../../../../features/jobs/clientJobsSlice";
import { useTranslation } from 'react-i18next';
import { selectCurrentLanguage, selectCurrentSocket } from "../../../../features/auth/authSlice";
import { useSelector } from 'react-redux';
import { fireCategoriesTr } from '../../../../utils/firebase.config';
import { useLocation } from 'react-router-dom';

let ManageJobs = (props) => {
    const { t } = useTranslation();
    const lang = useSelector(selectCurrentLanguage);
    const socket = useSelector(selectCurrentSocket);
    const location = useLocation();
    const [trCategoriesArr, setTrCategoriesArr] = useState(null);
    const [newCandidateCounts, setNewCandidateCounts] = useState({});
    const [completionSuccess, setCompletionSuccess] = useState(!!location.state?.completionSuccess);

    const { data, isLoading, refetch } = useGetJobListingByClientQuery();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isLoading) {
            fireCategoriesTr(setTrCategoriesArr); 
            dispatch(setCandidates(data?.candidates || []));
        }
    }, [isLoading, data?.candidates]);

    useEffect(() => {
        if (!socket) return undefined;
        const onCandidateApplied = ({ jobId }) => {
            setNewCandidateCounts(current => ({ ...current, [jobId]: (current[jobId] || 0) + 1 }));
            refetch();
        };
        socket.on('candidateApplied', onCandidateApplied);
        return () => socket.off('candidateApplied', onCandidateApplied);
    }, [socket, refetch]);

    const clearNewCandidates = jobId => setNewCandidateCounts(current => ({ ...current, [jobId]: 0 }));
    const activeJobs = data?.jobs?.filter(job => !(!!+job.isDone)) || [];
    const completedJobs = data?.jobs?.filter(job => !!+job.isDone) || [];

    const renderJob = j => {
        const index = trCategoriesArr?.input?.indexOf(j.category);
        return <JobListing key={j.id} {...j}
            category={(trCategoriesArr?.translated && trCategoriesArr.translated[index]) ? trCategoriesArr.translated[index][lang] : j.category}
            defaultCategoryName={j.category}
            newCandidates={newCandidateCounts[j.id] || 0}
            onCandidatesOpen={() => clearNewCandidates(j.id)}
            onCompleted={() => setCompletionSuccess(true)}
            candidates={data?.candidates?.filter(c => c.jobFK === j.id) || []} />;
    };

    return <div className="row">
        <div className="col-xl-12">
            <div className="dashboard-box margin-top-0">

                <div className="headline">
                    <h3><i className="icon-material-outline-business-center"></i> {t('MyJobListing')}</h3>
                </div>

                <div className="content">
                    {completionSuccess && <div style={{ margin: 20, padding: 14, color: '#176b3a', background: '#ecfdf3', borderRadius: 4 }}>
                        {t('CompletionSavedThanks')}
                    </div>}
                    <ul className="dashboard-box-list">
                        {!isLoading && activeJobs.map(renderJob)}
                    </ul>
                </div>
            </div>

            {completedJobs.length > 0 && <div className="dashboard-box margin-top-30">
                <div className="headline"><h3><i className="icon-feather-check-circle"></i> {t('CompletedJobs')}</h3></div>
                <div className="content"><ul className="dashboard-box-list">
                    {completedJobs.map(renderJob)}
                </ul></div>
            </div>}
        </div>
    </div>;
};

export default ManageJobs;
